import { useContext } from "react"

import { FileExplorerContext } from "./FileExplorerProvider"

export function useFileExplorerContext() {
  return useContext(FileExplorerContext)
}
